import { render } from "./WwfIcon.vue?vue&type=template&id=62d15f82"
import script from "./WwfIcon.vue?vue&type=script&lang=js"
export * from "./WwfIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__